<template>
    <div class="bg-primary-5 border rounded-4 p-24">
        <div class="flex justify-between items-center">
            <div>
                <p class="text-heading-1 font-semibold">{{ title }}</p>
                <p>{{ description }}</p>
            </div>
            <simple-button
                class="ml-8"
                display="primary"
                :loading="loading"
                @click="click"
            >
                {{ buttonLabel }}
            </simple-button>
        </div>
        <div v-if="collapseDiscover" class="flex flex-col justify-center items-center">
            <div class="w-4/5 border-t my-32"></div>
            <MultiPostingCollapse
                class="max-w-960"
                hideBorder
                hideActivateButton
            />
        </div>
    </div>
</template>
<script>
import SimpleButton from "../ui/SimpleButton.vue";
import MultiPostingCollapse from "./MultiPostingCollapse.vue";

export default {
    name: 'MultiPostingEmptyListItem',
    components: {SimpleButton, MultiPostingCollapse},
    props: {
        title: {
            type: String,
            default: 'Dummy title',
        },
        description: {
            type: String,
            default: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Maxime minima odit perspiciatis qui saepe tenetur. Consectetur dignissimos, distinctio eaque ipsum molestiae molestias nihil pariatur quaerat reiciendis repellendus similique tempora ut?',
        },
        buttonLabel: {
            type: String,
            default: 'Add',
        },
        loading: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            collapseDiscover: false,
        }
    },
    methods: {
        click() {
            this.$emit('onClick')
        }
    },
}
</script>